"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RadioTabs_1 = require("./RadioTabs");
exports.default = RadioTabs_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tabs/RadioTabs/index.js
// module id = 1260
// module chunks = 8